import { $core } from '#nuxt-api-party'
export const $me = () => $core('/users/me')